<template>
  <v-card
    flat
    color="transparent"
    style="margin-top: 10px; margin-bottom: 10px"
    width="1200px"
    min-height="500px"
  >
    <v-card-title class="justify-center">
      <div :style="{ fontSize: scale(23) + 'px' }">
        ขอหนังสือรับรองการหักภาษี ณ ที่จ่าย ฉบับทดแทน
      </div>
    </v-card-title>

    <!------------------------------------------ PC -------------------------------------------->
    <div v-if="!isMobile()">
      <v-card width="1200px" min-height="500px">
        <v-card-title
          ><div :style="{ fontSize: scale(20) + 'px' }">
            ข้อมูลผู้ถือหุ้น
          </div></v-card-title
        >
        <v-card-subtitle class="subtitle">
          <div :style="{ fontSize: scale(20) + 'px' }">
            ข้อมูลเพื่อขอ WHT ทดแทน
          </div>
        </v-card-subtitle>
        <v-col>
          <v-sheet rounded="lg">
            <div>
              <v-text-field
                v-model="inform_cifno_show"
                label="เลขที่บัตรประชาชน (Citizen ID)"
                readonly
              ></v-text-field>
              <v-text-field
                v-model="inform_tel_show"
                label="เบอร์โทรศัพท์"
                readonly
              ></v-text-field>
              <v-row>
                <v-col cols="12" sm="3" md="2">
                  <v-text-field
                    v-model="inform_prefix"
                    label="คำนำหน้าชื่อ"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="inform_name"
                    label="ชื่อ"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="inform_lastname"
                    label="นามสกุล"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
            <v-divider></v-divider>
            <div>
              <span style="color: red; margin-left: 8px;"> *** โปรดเลือกประเภทหุ้นกู้  </span>     
            </div>
            <div>
              <v-radio-group v-model="bondType" row mandatory>
                <v-radio label="หุ้นกู้เอกชน" value="NOTSTN"></v-radio>
                <v-radio label="หุ้นกู้อนุพันธ์แฝง" value="STN"></v-radio>
              </v-radio-group>
              <v-divider></v-divider>
            </div>
            <div>
              <input type="hidden" v-model="bondType" value="NOTSTN" />
              <v-data-table
                v-model="selected"
                :headers="headers"
                :value="selected"
                :items="IssuerVal.filter(item => {
                if (bondType === 'STN') {
                  return item.ISSUERCODE === 'KTB-USD';
                } else {
                  return item.ISSUERCODE !== 'KTB-USD';
                }
              })"
                item-key="Runid"
                :single-select="singleSelect"
                show-select
                class="elevation-1"
                :item-class="rowClass"
                :footer-props="{
                  'items-per-page-text': 'รายการต่อหน้า:',
                  'items-per-page-all-text': 'ทั้งหมด'
                }"
              >
                <template v-slot:footer>
                  <div style="padding: 16px; color: red; font-size: 14px;">
                    หมายเหตุ : สำหรับหุ้นกู้อนุพันธ์แฝง ท่านสามารถออกหนังสือรับรองหักภาษี ณ ที่จ่าย ได้เฉพาะงวดที่มีการจ่ายดอกเบี้ยเท่านั้น
                  </div>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:header.data-table-select="{ props }">
                  <v-simple-checkbox
                    :value="props.value"
                    @input="selectAllEnabled"
                  ></v-simple-checkbox>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.data-table-select="{ item, isSelected, select }">
                  <v-simple-checkbox
                    :value="isSelected"
                    :disabled="(item.ISSUERCODE === 'KTB-USD' && (item.IsPrincipleOnly === 'Y' || item.IsRate === 'N' )) || (item.ISSUERCODE !== 'KTB-USD' && item.isDownload === 'N')"
                    @input="select($event)"
                  ></v-simple-checkbox>
                </template>
              </v-data-table>
            </div>
          </v-sheet>
        </v-col>
      </v-card>
      <div class="footbtn">
        <div>
          <span style="color: red">{{ this.DownloadMessage }}</span>
        </div>
        <v-btn
          color="primary"
          @click="downloadFile()"
        >
          Download
        </v-btn>
        <v-btn
          text
          @click="goBack"
          style="position: absolute; right: 0px; margin-right: 10px"
        >
          กลับหน้าแรก
        </v-btn>
      </div>
    </div>

    <!------------------------------------------ Mobile -------------------------------------------->
    <div v-if="isMobile()">
      <v-card width="100%" min-height="500px">
        <v-card-title
          ><div :style="{ fontSize: scale(20) + 'px' }">
            ข้อมูลผู้ถือหุ้น
          </div></v-card-title
        >
        <v-card-subtitle class="subtitle">
          <div :style="{ fontSize: scale(20) + 'px' }">
            ข้อมูลเพื่อขอ WHT ทดแทน
          </div>
        </v-card-subtitle>
        <v-col>
          <v-sheet rounded="lg">
            <div>
              <v-text-field
                v-model="inform_cifno_show"
                label="เลขที่บัตรประชาชน (Citizen ID)"
                readonly
              ></v-text-field>
              <v-text-field
                v-model="inform_tel_show"
                label="เบอร์โทรศัพท์"
                readonly
              ></v-text-field>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="inform_prefix"
                    label="คำนำหน้าชื่อ"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="inform_name"
                    label="ชื่อ"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="inform_lastname"
                    label="นามสกุล"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
            <v-divider></v-divider>
            <div>
              <span style="color: red; margin-left: 8px;"> *** โปรดเลือกประเภทหุ้นกู้  </span>     
            </div>
            <div>
              <v-radio-group v-model="bondType" mandatory>
                <v-radio label="หุ้นกู้เอกชน" value="NOTSTN"></v-radio>
                <v-radio label="หุ้นกู้อนุพันธ์แฝง" value="STN"></v-radio>
              </v-radio-group>
              <v-divider></v-divider>
            </div>
            <div>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :value="selected"
                :items="IssuerVal.filter(item => {
                if (bondType === 'STN') {
                  return item.ISSUERCODE === 'KTB-USD';
                } else {
                  return item.ISSUERCODE !== 'KTB-USD';
                }
              })"
                item-key="Runid"
                :single-select="singleSelect"
                show-select
                class="elevation-1"
                :item-class="rowClass"
                :footer-props="{
                  'items-per-page-text': 'รายการต่อหน้า:',
                  'items-per-page-all-text': 'ทั้งหมด'
                }"
              >
                <template v-slot:footer>
                  <div style="padding: 16px; color: red; font-size: 14px;">
                    หมายเหตุ : สำหรับหุ้นกู้อนุพันธ์แฝง ท่านสามารถออกหนังสือรับรองหักภาษี ณ ที่จ่าย ได้เฉพาะงวดที่มีการจ่ายดอกเบี้ยเท่านั้น
                  </div>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:header.data-table-select="{ props }">
                  <v-simple-checkbox
                    :value="props.value"
                    @input="selectAllEnabled"
                  ></v-simple-checkbox>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.data-table-select="{ item, isSelected, select }">
                  <v-simple-checkbox
                    :value="isSelected"
                    :disabled="(item.ISSUERCODE === 'KTB-USD' && (item.IsPrincipleOnly === 'Y' || item.IsRate === 'N')) || (item.ISSUERCODE !== 'KTB-USD' && item.isDownload === 'N')"
                    @input="select($event)"
                  ></v-simple-checkbox>
                </template>
              </v-data-table>
            </div>
          </v-sheet>
        </v-col>
      </v-card>
      <div class="footbtn">
        <div>
          <span style="color: red">{{ this.DownloadMessage }}</span>
        </div>
        <v-btn color="primary" @click="downloadFile()">
          Download
        </v-btn>
        <v-btn
          text
          @click="goBack"
          style="position: absolute; right: 0px; margin-right: 10px"
        >
          กลับหน้าแรก
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="dialog" width="500">
      <v-card outlined>
        <v-card-title></v-card-title>
        <v-card-text min-height="300px" class="pb-0">
          <v-alert dense outlined type="error" class="alerttext">
            <div :style="{ fontSize: scale(16) + 'px' }">
              {{ dialogText }}
            </div>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog = false"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template> 

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from "moment";

export default {
  name: "download50_PaotangVer",
  data: () => ({
    dialog: false,
    dialogText: "",
    overlay: false,
    reftype: "1",
    bondType: "NOTSTN",
    cifno: "",
    inform_cifno_show: "",
    inform_tel_show: "",
    inform_prefix: "",
    inform_name: "",
    inform_lastname: "",
    DownloadMessage: "",
    singleSelect: false,
    IssuerVal: [],
    ClientIP: "",
    headers: [
      {
        text: "NO",
        align: "start",
        sortable: false,
        value: "Runid",
      },
      { text: "Issuer name", value: "ISSUERNAME" },
      { text: "Issuer Code", value: "ISSUERCODE" },
      { text: "Symbol", value: "SECURITYSYMBOL" },
      { text: "Holder ID", value: "HOLDER_ID" },
      { text: "Payment Date", value: "PAYMENT_DATE" },
      { text: "Period", value: "Period_No" },
    ],
    selected: [],
  }),
  computed: {
    ...mapGetters('Auth', ['getUserData']),
  },
  mounted() {
    const userData = this.getUserData;
    
    if (!userData || !userData.fromPaotang) {
      this.dialogText = "กรุณาเข้าสู่ระบบผ่านหน้าหลัก";
      this.dialog = true;
      setTimeout(() => {
        this.$router.push('/');
      }, 2000);
      return;
    }

    this.cifno = userData.refno;
    this.inform_prefix = userData.prefixname;
    this.inform_name = userData.firstname;
    this.inform_lastname = userData.lastname;
    
    var maskid = userData.refno;
    this.inform_cifno_show =
      maskid.substr(0, 1) +
      "-" +
      maskid.substr(1, 2) +
      "XXXXXX" +
      maskid.substr(9, 12);
    this.inform_tel_show = userData.mobile_otp;

    this.loadIssuerData();
  },
  methods: {
    ...mapActions('MDownload50Paotang', ['funcPostGetIssuerDetail', 'funcPostGetFileDownload']),
    
    selectAllEnabled() {
      if (this.selected.length > 0) {
        this.selected = [];
      } else {
        this.selected = this.IssuerVal.filter(item => {
          return !((item.ISSUERCODE === 'KTB-USD' && (item.IsPrincipleOnly === 'Y' || item.IsRate === 'N')) || (item.ISSUERCODE !== 'KTB-USD' && item.isDownload === 'N'));
        });
      }
    },
    
    rowClass(item) {
      if ((item.ISSUERCODE === 'KTB-USD' && (item.IsPrincipleOnly === 'Y' || item.IsRate === 'N')) || (item.ISSUERCODE !== 'KTB-USD' && item.isDownload === 'N')) {
        return 'disabled-row';
      }
      return '';
    },
    
    isMobile() {
      return window.innerWidth < 1280;
    },
    
    scale(num) {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return (num * 60) / 100;
        case "sm":
          return (num * 70) / 100;
        case "md":
          return (num * 90) / 100;
        case "lg":
          return (num * 95) / 100;
        case "xl":
          return num;
      }
    },

    loadIssuerData() {
      this.overlay = true;
      
      const postData = {
        Refno: this.cifno,
        Reftel: this.inform_tel_show,
        Refotp: "",  // No OTP needed from Paotang
        Refotpref: "",
        Topic: "twi50",
      };

      this.$store
        .dispatch("MDownload50Paotang/funcPostGetIssuerDetail", postData)
        .then((resp) => {
          if (resp != null && resp.length > 0) {
            this.IssuerVal = resp;
            if (this.IssuerVal[0]?.ReturnCode == "403") {
              this.dialogText = "ไม่สามารถโหลดข้อมูลได้";
              this.dialog = true;
              this.overlay = false;
              return;
            }
            this.DownloadMessage = this.IssuerVal[0]?.TextMessage || "";
            this.overlay = false;
          } else {
            this.IssuerVal = [];
            this.dialogText =
              "ไม่พบข้อมูล หนังสือรับรองการหักภาษี ณ ที่จ่าย ฉบับทดแทน กรุณาติดต่อนายทะเบียนหลักทรัพย์ที่เบอร์ 02-298-0821-30 กด 1";
            this.dialog = true;
            this.overlay = false;
          }
        })
        .catch((err) => {
          console.error("error", err);
          this.dialogText = "ขออภัย! การเชื่อมต่อมีปัญหา";
          this.dialog = true;
          this.overlay = false;
        });
    },

    downloadFile() {
      this.overlay = true;
      const postdt = [];
      this.selected?.forEach((value) => {
        postdt.push({
          Refno: this.cifno + "",
          Symbol: value.SECURITYSYMBOL + "",
          Holderid: value.HOLDER_ID + "",
          Period: value.Period_No + "",
        });
      });
      
      if (postdt.length == 0) {
        this.dialogText = "กรุณาเลือกรายการที่ต้องการดาวโหลด";
        this.dialog = true;
        this.overlay = false;
        return;
      }

      this.$store
        .dispatch("MDownload50Paotang/funcPostGetFileDownload", postdt)
        .then((resp) => {
          if (resp != null) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            if (resp.Filename != "false") {
              var byteCharacters = atob(resp.ImgByte2);
              var byteNumbers = new Array(byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              var byteArray = new Uint8Array(byteNumbers);
              let blob = new Blob([byteArray], { type: "application/pdf" }),
                url = window.URL.createObjectURL(blob);
              this.overlay = false;
              a.href = url;
              a.download = resp.Filename;
              a.click();
              window.URL.revokeObjectURL(url);
            } else {
              this.dialogText = "ไม่พบข้อมูลทวิ50 ที่ร้องขอ";
              this.dialog = true;
              this.overlay = false;
            }
          }
        })
        .catch((err) => {
          console.error(err?.message);
          if (err.response?.status == 401) {
            this.dialogText = "หมดเวลาการทำรายการ กรุณาทำรายการใหม่";
          } else {
            this.dialogText = "ขออภัย! การเชื่อมต่อมีปัญหา";
          }
          this.dialog = true;
          this.overlay = false;
        });
    },

    goBack() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
v-sheet {
  min-height: 400px;
}
.v-card__title {
  font-size: 20px;
}
v-card-title {
  font-family: "Ktcfast";
  font-size: 20px;
}
h2,
h3,
h4 {
  font-family: "Ktcfast";
}
.subtitle,
.alerttext {
  margin-top: 5px;
  font-family: "Ktcfast";
  font-size: 20px;
}
.footbtn {
  margin-top: 10px;
}
</style>
<style>
.disabled-row {
  background-color: #f5f5f5 !important;
  cursor: not-allowed !important;
}
.disabled-row td {
  color: #9e9e9e !important;
  opacity: 0.7 !important;
}
.disabled-row .v-simple-checkbox {
  opacity: 0.5 !important;
}
.disabled-row:hover {
  background-color: #eeeeee !important;
}
</style>
